import * as React from 'react';
import { toast } from 'react-toastify';
import { formatNumber } from '../Common/Utilities';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getFilter, setFilter } from '../Common/Utilities';

export default class APPayments extends React.Component {
	constructor() {
		super();

		this.state = {
			data: [],
			lastUpdated: "",
			filterText: getFilter(["SystemSetup", "AP_Payments", "searchText"]) || '',
			sortModel: getFilter(["SystemSetup", "AP_Payments", "sortModel"]) || [],
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.mainGridRef = React.createRef();
	}

	componentDidMount() {

		const gridRef = this.mainGridRef?.current;
		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([this.state.filterText]);
		}
		this.fetchAPPayments();
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}

	refresh_clickHandler(event) {
		this.props.inProgress(true);
		let functionName = "getappayment";
		let messageName = "AP Payments";
		httpGet("/api/Adapter/getSyncData/" + functionName)
			.then(response => {
				var data = response.data;
				this.props.inProgress(false);
				if (data)
					toast.success(messageName + ' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				this.props.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
		
	}
	fetchAPPayments() {
		var that = this;

		this.props.inProgress(true);

		httpGet('/api/setup/appayments')
			.then((response) => {
				var data = response.data;
				let records = (data.records || []).map((e, i) => { let d = { ...e, rowId: i }; return d; });

				var localDateString = data.lastUpdated == null ? "" : new Date(data.lastUpdated).toLocaleString();
				that.setState({ data: records, lastUpdated: localDateString });

				this.props.inProgress(false);
			})
			.catch((error) => {
				this.props.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}
	

	render() {
		let count = 1;
		return (
			<div>
				<h1>AP Payments</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							gridRef={this.mainGridRef}
							title={"Last Updated: " + this.state.lastUpdated}
							customcomponent={this.getRefreshButton()}
							setFilterText={(text) => {
								const trimmed = text?.trim() || '';
								this.setState({ filterText: trimmed }, () => {
									
									setFilter(['SystemSetup', "AP_Payments", 'searchText'], trimmed);
								});
							}}
							highlightSearchTextOnMainScreenGrid={true}
							onSortModelChange={(model) => {
								this.setState({ sortModel: model });
								setFilter(['SystemSetup', "AP_Payments", 'sortModel'], model);
							}}
							sortModel={this.state.sortModel}
							columns={[
								{
									headerName: 'Vendor',
									field: 'vendorCode',
									flex: 0.5,
								},
								{
									headerName: 'Check Number',
									field: 'checkNumber',
									width: 300,
									flex: 0.5,
								},
								{
									headerName: 'Invoice Number',
									field: 'invoiceNumber',
									width: 300,
									flex: 0.5,
								},
								{
									headerName: 'Document Date',
									field: 'documentDate',
									type: 'date',
									flex: 0.5,
									valueGetter: ({ value }) => value && new Date(value),
								},
								{
									headerName: 'Payment Amount',
									field: 'paymentAmount',
									type: 'currency',
									headerAlign: 'right',
									align: 'right',
									flex: 0.5,
									//valueGetter: ({ value }) => value && new Date(value),
									renderCell: rowData => formatNumber(rowData.row.paymentAmount) + " " + rowData.row.currencyCode
								}
							]}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</div>
			</div>
		);
	}
}
